import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AccordionComponent } from './components/accordion/accordion.component';
import { AppendixComponent } from './components/appendix/appendix.component';
import { AutoCompleteAddressComponent } from './components/auto-complete-address/auto-complete-address.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { CheckboxListComponent } from './components/checkbox-list/checkbox-list.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { FileSelectorComponent } from './components/file-selector/file-selector.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { IconComponent } from './components/icon/icon.component';
import { InputComponent } from './components/input/input.component';
import { InputErrorComponent } from './components/input-error/input-error.component';
import { LoaderComponent } from './components/loader/loader.component';
import { MessageComponent } from './components/message/message.component';
import { OnlineStatusComponent } from './components/online-status/online-status.component';
import { ProgressContainerComponent } from './components/progress-container/progress-container.component';
import { RadioComponent } from './components/radio/radio.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { SwitchComponent } from './components/switch/switch.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { KeyValueComponent } from './components/key-value/key-value.component';
import { ImageSelectorComponent } from './components/image-selector/image-selector.component';

import { FilterPipe } from './pipes/filter/filter.pipe';
import { NumberPipe } from './pipes/number/number.pipe';

import 'dayjs/locale/nl-be';
import * as dayjs from 'dayjs';
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";

dayjs.locale('nl-be');

const components = [
	AccordionComponent,
	AppendixComponent,
	AutoCompleteAddressComponent,
	CheckboxComponent,
	CheckboxListComponent,
	DatepickerComponent,
	DropdownComponent,
	FileSelectorComponent,
	FooterComponent,
	HeaderComponent,
	IconComponent,
	ImageSelectorComponent,
	InputComponent,
	InputErrorComponent,
	KeyValueComponent,
	LoaderComponent,
	MessageComponent,
	OnlineStatusComponent,
	ProgressContainerComponent,
	RadioComponent,
	SearchInputComponent,
	SwitchComponent,
	TooltipComponent,
];

const pipes = [FilterPipe, NumberPipe];

const modules = [CommonModule, ReactiveFormsModule, RouterModule];

@NgModule({
	declarations: [...components, ...pipes],
	imports: [...modules],
	providers: [provideHttpClient(withInterceptorsFromDi())],
	exports: [...components, ...pipes, ...modules],
})
export class CoreModule {}
